import { render } from "./LdJson.vue?vue&type=template&id=563da306"
import script from "./LdJson.vue?vue&type=script&lang=js"
export * from "./LdJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__